module.exports = function () {

    let module = {};

    module.environment = process.env.NODE_ENV;
    module.isLive = (module.environment == 'production') ? true : false;
    module.isStaging = (module.environment == 'staging') ? true : false;
    module.isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false;


    module.log = function (message) {
        if (!module.isStaging && !module.isLive)
            return console.log(message);
    };

    // Only include Bootstrap modules required
    module.initBootstrap = function () {
        require('bootstrap/js/dist/index');
        require('bootstrap/js/dist/alert');
        require('bootstrap/js/dist/button'); // required for auto complete library
        //require('bootstrap/js/dist/carousel');
        require('bootstrap/js/dist/collapse');
        require('bootstrap/js/dist/dropdown');
        require('bootstrap/js/dist/modal');
        // require('bootstrap/js/dist/popover');
        // require('bootstrap/js/dist/scrollspy');
        require('bootstrap/js/dist/tab');
        // require('bootstrap/js/dist/tooltip');
        // require('bootstrap/js/dist/util');
    };

    // module.initDatepicker = function () {
    //     require('jquery-ui/ui/keycode');
    //     require('jquery-ui/ui/widgets/datepicker');
    //
    //     $('.datepicker').datepicker({
    //         dateFormat: "d MM yy",
    //         changeMonth: true,
    //         changeYear: true,
    //         maxDate: "-18y"
    //     });
    // }


    module.initLazyLoad = function () {
        const lasysizes = require('lazysizes/lazysizes');
        lazySizes.cfg.lazyClass = 'lazy';
    };

    module.initRrssb = function () {
        require('rrssb');
    };

    module.initTooltips = function () {

        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover focus',
            placement: 'bottom',
            container: 'body'
        });
    };

    module.initStickyEl = function () {

        // Get sticky el's
        let el = $('.is-sticky');

        sessionStorage.setItem('height', $('header').height());

        // When the user scrolls the page, execute myFunction
        window.onscroll = function () {
            module.addStickyClass();
        };

        module.addStickyClass();
    };

    module.addStickyClass = function () {

        let body = $('body');

        let height = sessionStorage.getItem('height') ? sessionStorage.getItem('height') : $('header').height();

        if (window.pageYOffset >= (height / 2) && window.pageYOffset < height) {
            body.addClass("before-stuck").removeClass("stuck").css('padding-top', '0');
        } else if (window.pageYOffset == 0) {
            body.removeClass("stuck").removeClass("before-stuck").css('padding-top', '0');
        } else if (window.pageYOffset > height) {
            body.addClass("stuck").removeClass("before-stuck").css('padding-top', height + 'px');

        }

    };


    // module.navDropdownHover = function () {
    //
    //     const $dropdown = $(".dropdown");
    //     const $dropdownToggle = $(".dropdown-toggle");
    //     const $dropdownMenu = $(".dropdown-menu");
    //     const showClass = "show";
    //
    //     $(window).on("load resize", function() {
    //         if (this.matchMedia("(min-width: 768px)").matches) {
    //             $dropdown.hover(
    //                 function() {
    //                     const $this = $(this);
    //                     $this.addClass(showClass);
    //                     $this.find($dropdownToggle).attr("aria-expanded", "true");
    //                     $this.find($dropdownMenu).addClass(showClass);
    //                 },
    //                 function() {
    //                     const $this = $(this);
    //                     $this.removeClass(showClass);
    //                     $this.find($dropdownToggle).attr("aria-expanded", "false");
    //                     $this.find($dropdownMenu).removeClass(showClass);
    //                 }
    //             );
    //         } else {
    //             $dropdown.off("mouseenter mouseleave");
    //         }
    //     });
    // };


    module.announcementBarDismiss = function () {
        if ($('#announcement-dismiss').length) {
            $('#announcement-dismiss').click(function () {
                $.get("/announcement-dismiss", function () {
                    console.log("Announcement bar dismissed");
                    $('#announcement-dismiss').fadeOut(300);
                })
            });
        }
    };

    module.initLightbox = function () {
        require('ekko-lightbox');
        $(document).on('click', '[data-toggle="lightbox"]', function (event) {
            event.preventDefault();
            $(this).ekkoLightbox({
                alwaysShowClose: true,
                leftArrow: '<i class="fa fa-chevron-left left"></i>',
                rightArrow: '<i class="fa fa-chevron-right right"></i>'
            });
        });
    };

    module.initMobileMenu = function () {
        require('../plugins/jquery-simple-mobile-menu');
        $(".mobile_menu").simpleMobileMenu();
        $('#sm_menu_ham').addClass('icon').prependTo('.mobile-icons');
    };

    module.initSlickCarousel = function () {
        require('slick-carousel');

        $('.slick.shortcode-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            fade: true,
            arrows: false,
            dots: true,
            cssEase: 'linear',
        });

        $('.slick.testimonials-slides').slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            arrows: false,
            cssEase: 'linear',

            responsive: [

                {
                    breakpoint: 992, // sm
                    settings: {
                        slidesToShow: 1
                    }
                },

            ]


        });

        $('.slick.slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: false,
            dots: true,
        });

        $('.slick.slides').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: false,
            dots: true,
            appendArrows: $('.arrows-container .arrows')
        });


        $('.slick.subpages').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            arrows: true,
            dots: false,

            responsive: [
                {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 2
                    }
                },

                {
                    breakpoint: 540,
                    settings: {
                        slidesToShow: 1
                    }
                },
            ]
        });

        $('.slick.carousel').slick({
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            autoplay: true,
            centerMode: true,
            centerPadding: '50px',
            draggable: true,
            arrows: false,
            responsive: [
                {
                    breakpoint: 968,
                    settings: {
                        slidesToShow: 5
                    }
                },

                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3
                    }
                },
            ]
        });

        $('.slick.card-carousel').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '200px',
            draggable: true,
            arrows: false,
            responsive: [
                {
                    breakpoint: 968,
                    settings: {
                        slidesToShow: 2
                    }
                },
            ]
        });

    };


    module.scrollToAnchor = function () {
        $('a[href^=\\#scroll-]').on('click', function (e) {
            e.preventDefault();

            let collapseId = $(this).attr('href').replace('scroll-', '');

            console.log(collapseId);

            module.scrollToElement(collapseId);
        });
    };


    module.detectUrlScrollHash = function () {
        if (window.location.hash.indexOf('scroll-') == 1) {

            let el = window.location.hash.replace('scroll-', '');

            console.log('Attempting automatic scroll to ' + el);

            this.scrollToElement(el);
        }
    };

    module.scrollToElement = function (element) {

            console.log('Attempt to scroll to el ' + element);

            $('html,body').animate({scrollTop: $(element).offset().top - 100}, 'slow', function () {
                if ($(element).length && $(element).next().hasClass('collapse')) {
                    $(element).next().collapse('show');
                }

            });

    };

    module.scrollToAccordionItem = function () {

        $('.accordion').on('shown.bs.collapse', function (event) {
            let getHeaderEl = $('#' + event.target.id).prev('.card-header').attr('id');

            if (getHeaderEl)
                module.scrollToElement('#' + getHeaderEl);
        });

    };

    module.initWowJs = function () {
        const {WOW} = require('wowjs');
        new WOW({
            mobile: false,
        }).init();
    };


    module.convertCryptedEmails = function () {

        $('.cryptedmail').each(function () {

            let
                el = $(this).find('span'),
                e = el.data('name') + '@' + el.data('domain') + '.' + el.data('tld');

            $(this).attr('href', 'mailto:' + e).removeClass('cryptedmail').find('span');

            if ((typeof el.data('show-value') == 'undefined') || el.data('show-value'))
                el.html(el.data('value') ? el.data('value') : e);
        });
    };

    module.isInViewport = function (element) {
        if (!element) return false;
        if (1 !== element.nodeType) return false;

        var html = document.documentElement;
        var rect = element.getBoundingClientRect();

        return !!rect &&
            rect.bottom >= 0 &&
            rect.right >= 0 &&
            rect.left <= html.clientWidth &&
            rect.top <= html.clientHeight;
    };

    module.initOdometer = function () {
        const odometer = require('../plugins/odometer.min');

        if ($('.odometer').length) {
            window.addEventListener('scroll', function (event) {

                if (module.isInViewport(document.querySelector('#odometer'))) {

                    odometer.init();

                    let timeout = 0;

                    $('.odometer').each(function () {
                        let od = $(this);

                        setTimeout(function () {
                            od.html(od.data('value'))
                        }, timeout);

                        timeout = timeout + 500;
                    });
                }
            });
        }

    };

    module.fadeImage = function () {

        $(document).ready(function () {
            // Check for iframes within .video-url
            var iframe = $('.video-url iframe');

            // If an iframe exists, add a load event listener
            if (iframe.length) {
                iframe.on('load', function () {
                    setTimeout(function () {
                        $('#slideImage').fadeTo(1000, 0, function () {
                            $(this).addClass('d-lg-none');
                        });
                    }, 1500); // 1000 milliseconds delay after iframe loads
                });
            }
        });
    };

    module.initTingleModalJs = function () {

        const Tingle = require('tingle.js');

        var modal = new Tingle.modal({
            stickyFooter: false,
            footer: false,
            closeMethods: ['overlay', 'button', 'escape'],
            cssClass: ['custom-class-1', 'custom-class-2'],
        });

        $('.md-trigger').click(function (event) {
            let id = $(this).data('id');
            modal.setContent($('#' + id).html());
            modal.open();
        });
    };

    module.imageToggle = function () {

        $(document).ready(function() {
            // When any accordion block is toggled
            $('#accordionBlock').on('shown.bs.collapse', function (e) {
                // Get the ID of the expanded collapse block
                var targetId = $(e.target).attr('id').replace('collapseBlock-', '');

                // Show the corresponding image
                $('#image-' + targetId).css('opacity', '1');

                // Hide images for the collapsed blocks
                $('#accordionBlock .collapse').not(e.target).each(function() {
                    var collapsedId = $(this).attr('id').replace('collapseBlock-', '');
                    $('#image-' + collapsedId).css('opacity', '0');
                });
            });

            // Initially hide all images except the first one
            $('#accordionBlock .collapse').each(function(index) {
                if (index !== 0) {
                    var collapsedId = $(this).attr('id').replace('collapseBlock-', '');
                    $('#image-' + collapsedId).css('opacity', '0');
                }
            });
        });

    };

    module.faqToggle = function () {

        document.querySelectorAll("[data-toggle='collapse']").forEach(function (toggle) {
            toggle.addEventListener("click", function () {
                var target = document.querySelector(this.getAttribute("data-target"));
                var faq = this.closest(".faq");

                if (target.classList.contains("show")) {
                    faq.classList.remove("active"); // Remove if already open
                } else {
                    document.querySelectorAll(".faq").forEach(f => f.classList.remove("active")); // Reset others
                    faq.classList.add("active"); // Add active class to the clicked FAQ
                }
            });
        });

        // Handle Bootstrap's collapse events for better accuracy
        document.querySelectorAll(".collapse").forEach(function (collapse) {
            collapse.addEventListener("show.bs.collapse", function () {
                this.closest(".faq").classList.add("active");
            });

            collapse.addEventListener("hide.bs.collapse", function () {
                this.closest(".faq").classList.remove("active");
            });
        });


    };


    return module;

};

